import { useState } from 'react'
import { Avatar } from '../../components/index.js'
import { useChatStore } from '../../stores/useChatStore.js'
import type { UserProfile } from '../../types/user.js'

interface NewConversationSearchProps {
  users: UserProfile[]
  currentUser: UserProfile
  onSelectUser: (user: UserProfile) => void
  onClose: () => void
}

export function NewConversationSearch({ users, currentUser, onSelectUser, onClose }: NewConversationSearchProps) {
  const [search, setSearch] = useState('')
  const chats = useChatStore((s) => s.chats)
  const setActiveChat = useChatStore((s) => s.setActiveChat)

  const otherUsers = users.filter((u) => u.id !== currentUser.id)
  const filtered = otherUsers.filter(
    (u) => !search || u.name.toLowerCase().includes(search.toLowerCase()),
  )

  function handleSelectUser(user: UserProfile) {
    const existingChat = chats.find(
      (c) => c.type === 'direct' && c.members?.some((m) => m.userId === user.id),
    )
    if (existingChat) {
      setActiveChat(existingChat.id)
      onClose()
    } else {
      onSelectUser(user)
    }
  }

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="flex items-center gap-3 border-b border-(--color-border) px-4 py-3">
        <button
          onClick={onClose}
          className="flex h-8 w-8 items-center justify-center rounded-md text-(--color-text-secondary) hover:bg-(--color-bg-tertiary) transition-colors"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h3 className="text-sm font-semibold text-(--color-text-primary)">Nova conversa</h3>
      </div>

      {/* Search */}
      <div className="border-b border-(--color-border) px-4 py-2">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar colega..."
          autoFocus
          className="w-full rounded-md border border-(--color-border) bg-(--color-bg-secondary) px-3 py-2 text-sm text-(--color-text-primary) placeholder:text-(--color-text-muted) focus:border-(--color-primary) focus:outline-none"
        />
      </div>

      {/* User list */}
      <div className="flex-1 overflow-y-auto">
        {filtered.map((u) => (
          <button
            key={u.id}
            onClick={() => handleSelectUser(u)}
            className="flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-(--color-bg-tertiary) transition-colors"
          >
            <Avatar name={u.name} avatarUrl={u.avatarUrl} size="md" />
            <div>
              <p className="text-sm font-medium text-(--color-text-primary)">{u.name}</p>
              <p className="text-xs text-(--color-text-muted)">
                {u.role === 'administrator' ? 'Administrador' : 'Agente'}
              </p>
            </div>
          </button>
        ))}
        {filtered.length === 0 && (
          <p className="px-4 py-8 text-center text-sm text-(--color-text-muted)">
            Nenhum colega encontrado
          </p>
        )}
      </div>
    </div>
  )
}
